import { useContext } from 'react';
import { NotificationContext } from '@shared/contexts/NotificationContext.tsx';
import { NotificationContextValues } from '@app/types/core/notification.ts';

const useNotification = (): NotificationContextValues => {
  const context = useContext(NotificationContext);

  if (!context)
    throw new Error(
      'NotificationContext must be use inside NotificationProvider'
    );

  return context;
};

export default useNotification;
